import { DynComponentMapping } from '@ups/xplat/dynamic-render';
import {
  AiCoachingResultsComponent,
  DynamicButtonGroupComponent,
  DynamicChartComponent,
  DynamicCheckboxComponent,
  DynamicCircleComponent,
  DynamicCopyLinkButtonComponent,
  DynamicDataLabelsComponent,
  DynamicDateComponent,
  DynamicFileComponent,
  DynamicHtmlTextComponent,
  DynamicImageComponent,
  DynamicInputComponent,
  DynamicLabelComponent,
  DynamicNumericTextboxComponent,
  DynamicRadioComponent,
  DynamicRedactedComponent,
  DynamicSafetyAtRiskComponent,
  DynamicSignatureComponent,
  DynamicTextareaComponent,
  DynamicTypeaheadAutocompleteComponent,
  DynamicTypeaheadCategoryComponent,
  DynamicTypeaheadCompanyComponent,
  DynamicTypeaheadComponent,
  DynamicTypeaheadCustomersComponent,
  DynamicTypeaheadEmployeeComponent,
  DynamicTypeaheadFacilityComponent,
  DynamicTypeaheadGlAccountComponent,
  DynamicTypeaheadPurchaseOrderComponent,
  DynamicTypeaheadIconsComponent,
  DynamicTypeaheadJobComponent,
  DynamicTypeaheadVendorComponent,
  DynamicTypeaheadOfficeComponent,
  DynamicTypeaheadSublocationComponent,
  DynamicAccordionComponent,
  DynamicButtonComponent,
  DynamicTextareaDirective,
  DYNAMIC_TYPEAHEADS,
  DYNAMIC_HELPER_COMPONENTS,
} from '.';

export const DYNAMIC_ITEM_COMPONENTS = [
  DynamicChartComponent,
  DynamicCheckboxComponent,
  DynamicCircleComponent,
  DynamicDateComponent,
  DynamicHtmlTextComponent,
  DynamicInputComponent,
  DynamicImageComponent,
  DynamicLabelComponent,
  DynamicNumericTextboxComponent,
  DynamicRadioComponent,
  DynamicSafetyAtRiskComponent,
  DynamicTextareaComponent,
  DynamicTextareaDirective,
  DynamicTypeaheadComponent,
  DynamicFileComponent,
  DynamicButtonGroupComponent,
  DynamicSignatureComponent,
  DynamicCopyLinkButtonComponent,
  ...DYNAMIC_TYPEAHEADS,
  ...DYNAMIC_HELPER_COMPONENTS,
  DynamicRedactedComponent,
  DynamicDataLabelsComponent,
  AiCoachingResultsComponent,
  DynamicAccordionComponent,
  DynamicButtonComponent,
];

/* eslint-disable @typescript-eslint/naming-convention */
export const DYNAMIC_COMPONENT_MAPPING: DynComponentMapping = {
  buttongroup: DynamicButtonGroupComponent,
  circle: DynamicCircleComponent,
  'ai-coaching': AiCoachingResultsComponent,
  chart: DynamicChartComponent,
  checkbox: DynamicCheckboxComponent,
  copyLinkButton: DynamicCopyLinkButtonComponent,
  dataLabels: DynamicDataLabelsComponent,
  date: DynamicDateComponent,
  signature: DynamicSignatureComponent,
  email: DynamicInputComponent,
  file: DynamicFileComponent,
  image: DynamicImageComponent,
  input: DynamicInputComponent,
  label: DynamicLabelComponent,
  'html-text': DynamicHtmlTextComponent,
  number: DynamicNumericTextboxComponent,
  numerictextbox: DynamicNumericTextboxComponent,
  phone: DynamicInputComponent,
  radio: DynamicRadioComponent,
  redacted: DynamicRedactedComponent,
  safetyatrisk: DynamicSafetyAtRiskComponent,
  text: DynamicInputComponent,
  textarea: DynamicTextareaComponent,
  typeahead: DynamicTypeaheadComponent,
  'typeahead-autocomplete': DynamicTypeaheadAutocompleteComponent,
  'typeahead-category': DynamicTypeaheadCategoryComponent,
  'typeahead-company': DynamicTypeaheadCompanyComponent,
  'typeahead-customers': DynamicTypeaheadCustomersComponent,
  'typeahead-employee': DynamicTypeaheadEmployeeComponent,
  'typeahead-facilities': DynamicTypeaheadFacilityComponent,
  'typeahead-gl-account': DynamicTypeaheadGlAccountComponent,
  'typeahead-purchase-order': DynamicTypeaheadPurchaseOrderComponent,
  'typeahead-icons': DynamicTypeaheadIconsComponent,
  'typeahead-job': DynamicTypeaheadJobComponent,
  'typeahead-vendor': DynamicTypeaheadVendorComponent,
  'typeahead-office': DynamicTypeaheadOfficeComponent,
  'typeahead-sublocation': DynamicTypeaheadSublocationComponent,
  accordion: DynamicAccordionComponent,
  button: DynamicButtonComponent,
};
